import { useInfiniteQuery } from '@tanstack/react-query';

import { RQ_SOLD_SHOP_PRODUCTS } from '@/modules/ReactQuery/cacheKeys.ts';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { getNextPageParam } from '@/modules/pagination/getNextPageParam';
import { fetchShopProductsByStatus } from '@/modules/shop/api';
import { SHOP_PAGE_SIZE } from '@/modules/shop/constants';

export function useSoldShopProducts(sellerId?: number, limit = SHOP_PAGE_SIZE) {
  const { language: lang } = useCurrentLanguage();

  return useInfiniteQuery({
    queryKey: [RQ_SOLD_SHOP_PRODUCTS, sellerId, lang],
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchShopProductsByStatus(
        sellerId as number,
        {
          lang,
          after: pageParam,
          limit: String(limit),
        },
        'sold'
      ),
    initialPageParam: undefined,
    getNextPageParam,
    enabled: !!sellerId,
  });
}
